const AppMessage = {
  invalidPhoneNumber: "This Service Is Only Available for Jazz Users",
  validPhoneNumber: "Please enter a phone number",
  invalidOtp: "Invalid OTP",
  enterVlidOtp: "Please enter valid 4 digit OTP",
  initializationFailed:
    "Something went wrong. Please check your network connection and",
  sessionExpire: "Session is expired",
  subEndConfirmation:
    "Unsubscribing will limit your access - you'll only be able to watch ",
  MySubscriptionsFailed: "Something went wrong.\nPlease Try again.",
  MySubscriptionsSuccess: "You have successfully\nUnsubscribed.",
  listError:
    "An error occurred while processing your request. Please try again later.",
  listEmpty:
    "No data found while processing your request. Please try again later.",
  privacyPolicyMsg: "Please accept the Privacy Policy to continue.",
  requestFailed: "Something went wrong. Please try again later",
  subOneMoreCatergory:
    "Subscribe to any one more category to enjoy unlimited access to all content ",
  subTwoMoreCatergory:
    "Subscribe to any two more categories to enjoy unlimited access to all content ",
  premiumSubscription:
    "Congratulations! You’ve successfully subscribed to 3 categories and unlocked full access to all content on the platform.",
  searchMsg: "No data to show for search query",
  activeJazzCashMsg: "You have an active JazzCash subscription",
  activeSubMsg: "You have an active subscription",
  otpFail:"Unable to send OTP, Please try again.",
  checkTerms:"Please accept the terms and conditions to proceed.",
  subFail:"Unable to subscribe, Please try again."

};
export default AppMessage;
